import { useSelector } from 'react-redux'
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import Btn from '../../components/shared/button/Btn'
import IsArayanSurucuContainer from '../../components/ilanlarContainers/IsArayanSurucuContainer'
import { useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { getAllJobSeekerAdvert } from '../../features/ilanlar/ilanlarSlice'
import InputSelectCity from '../../components/shared/input/new/InputSelectCity'
import Pagination from '../../components/shared/Pagination'

const Container = styled.div`

width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
            gap: 60px;
            margin: 0 30px;
            margin-top: 20px;
            color: ${({ theme }) => theme.mainTextColor};
            .top-container{
                display: flex;
                align-items: center;
                margin-bottom: 30px;
                gap: 20px;
            }
            .titles {
              width: 100%;
              display: grid;
              grid-template-columns:  repeat(9, 1fr);
              padding-inline: 10px;
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-lg);
                p{
                  text-align: center;
                }
            }
        }
    }
`
const titles = ["İlan Tarihi", "Adı Soyadı", "Cep Telefonu", "Ehliyet Sınıfı", "SRC Sınıfı", "Çalışmak İstenilen İl / İller", "Talep Edilen Maaş", "Ağır Vasıta Tecrübesi (Yıl)", "Not/Açıklama"]

const IsArayanSuruculer = () => {
  const {theme} = useSelector((state) => state.layout)
  const dispatch = useDispatch()
  const {jobSeekerList} = useSelector((state) => state.ilanlar)
  const [workCity, setWorkCity] = useState("")

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const totalPages = Math.ceil(jobSeekerList / itemsPerPage);

  useEffect(() => {
    dispatch(getAllJobSeekerAdvert({workCity: workCity, page: currentPage}))
  }, [workCity, currentPage])

  return (
    <Container>
      <PageTopTitle title={"İş Arayan Sürücüler"} position='sticky'/>
      <div className="wrapper">
        <div className="content">

          <div className="top-container">
            <InputSelectCity data={workCity?.value} setData={setWorkCity} name={"workCity"} labelText={"Çalışılacak İl"} />
            <Btn color='#E85446' bgColor='transparent' padding='0 10px' handleClick={() => {setWorkCity(""); setCurrentPage(1)}} >Temizle</Btn>
          </div>

          <div className="titles">
            {titles.map((item) => (
              <p>{item}</p>
            ))}
          </div>

          {jobSeekerList.map((item) => (
            <IsArayanSurucuContainer data={item} />
          ))}

        {(jobSeekerList && jobSeekerList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
        </div>
      </div>
    </Container>
  )
}

export default IsArayanSuruculer